import { NavLink } from 'react-router-dom';

import { useIdentity } from './identity';

const linkCls = 'inline-flex min-h-11 items-center text-xs text-fg-muted underline-offset-2 hover:text-fg hover:underline md:min-h-0';

/** Who is signed in, at the bottom of the sidebar. Spark-board's account menu, without the popover: Staff and Sign out. */
const IdentityMenu = () => {
  const { me, signOut } = useIdentity();
  if (!me) return null;
  return (
    <div className="mb-4 px-2">
      <div className="flex items-center gap-1.5">
        <span className="truncate text-sm text-fg-strong">{me.name}</span>
        {me.role === 'admin' ? (
          <span className="shrink-0 rounded bg-brand/15 px-1.5 py-px text-[10px] font-semibold uppercase tracking-wide text-brand">Admin</span>
        ) : null}
      </div>
      {me.email ? <div className="truncate text-xs text-fg-faint">{me.email}</div> : null}
      <div className="mt-1.5 flex gap-3">
        <NavLink to="/settings/staff" className={linkCls}>
          Staff
        </NavLink>
        <button type="button" onClick={signOut} className={linkCls}>
          Sign out
        </button>
      </div>
    </div>
  );
};

export default IdentityMenu;
